<div class="container">
  <div class="card-body p-0 xp-xl-3">
    <div class="row justify-content-center mt-3">
      <ng-container *ngIf="!loading; else loader">
        <div class="w-100" style="min-height: 300px">
          <div *ngIf="selectedProForm">
            @if(this.quizSummaryParams) {
            <app-proforms-quiz-summary
              [requestParams]="this.quizSummaryParams"
              [excludeDefaultFilters]="true" />
            }
            <div *ngFor="let order of questionsOrder; let i = index">
              <ng-container
                *ngFor="
                  let requestParams of observedAnswersParams;
                  let i = index
                ">
                @if(getQuestionId(requestParams) === order){
                <div
                  id="observed-{{ questionTitles[i] }}"
                  class="p-0 p-md-5 mx-xl-3">
                  <div class="position-relative my-4">
                    <h3 class="fs-21 fw-800 text-center">
                      {{ questionTitles[i] }}
                    </h3>
                    <div class="fs-11 fw-800 color-gray mb-3 text-center">
                      {{ optionTypes[i] | uppercase }}
                    </div>
                    @if(optionTypes[i] === 'radio') {
                    <app-report-controller
                      chartId="proform-{{ questionTitles[i] }}"
                      [chartType]="[chartTypes.Donut]"
                      [colorPalette]="chartColors"
                      [tooltipTrigger]="'item'"
                      [limitDataPresentation]="5"
                      [requestParams]="requestParams"
                      [excludeDefaultFilters]="true" />
                    } @else {
                    <app-report-controller
                      chartId="proform-{{ questionTitles[i] }}"
                      cardHeight="18rem"
                      [percentage]="true"
                      [chartType]="[chartTypes.HorizontalBar]"
                      [chartColor]="['#d95195']"
                      [tooltipTrigger]="'item'"
                      [horizontalBarThreshold]="5"
                      [gridDimensions]="{
                top: '30px',
                left: '23px',
                right: '15px',
                bottom: '35px',
              }"
                      [requestParams]="requestParams"
                      [excludeDefaultFilters]="true" />
                    }
                  </div>
                </div>
                }
              </ng-container>

              <ng-container
                *ngFor="let requestParams of textAnswersParams; let i = index">
                @if(getQuestionId(requestParams) === order){
                <div
                  id="observed-{{ textQuestionTitles[i] }}"
                  class="p-0 p-md-5 mx-3">
                  <h3 class="fs-21 fw-800 text-center">
                    {{ textQuestionTitles[i] }}
                  </h3>
                  <div class="fs-11 fw-800 color-gray text-center mb-3">
                    {{ textQuestionTypes[i] | uppercase }}
                  </div>
                  @if(textQuestionTypes[i] === 'text' || textQuestionTypes[i]
                  === 'textarea') {
                  <app-proforms-text-response
                    [requestParams]="requestParams"
                    [fieldId]="textQuestionIds[i]"
                    [questionTitle]="textQuestionTitles[i]" />
                  } @if(textQuestionTypes[i] === 'attachment') {
                  <app-proforms-attachment-response
                    [requestParams]="requestParams"
                    [fieldId]="textQuestionIds[i]"
                    [questionTitle]="textQuestionTitles[i]" />
                  }
                </div>
                }
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #loader>
        <div class="w-100" style="height: 500px">
          <app-loader></app-loader>
        </div>
      </ng-template>

      <div class="mt-5 text-muted small text-end">
        Data last refreshed at {{ lastUpdatedDate }}
      </div>
    </div>
  </div>
</div>
